import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import { GameOver } from '@fantaz/shared/data-access/models';
import { map, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class GameOverService {
  constructor(
    private utilsService: UtilsService,
    private http: HttpClient,
  ) {}

  getGameOver(
    playInstance: string,
    userUuid: string,
    pageIndex?: number,
    pageSize?: number,
    paginated?: boolean,
    extra?: Record<string, string | number | boolean>,
  ): Observable<GameOver> {
    let params = new HttpParams();
    params = params.append('_cache', Date.now());

    if (pageIndex) {
      params = params.append('pageIndex', pageIndex.toString());
    }
    if (pageSize) {
      params = params.append('pageSize', pageSize.toString());
    }
    if (paginated) {
      params = params.append('paginated', paginated.toString());
    }

    if (extra) {
      Object.keys(extra).forEach((key) => {
        params = params.append(key, extra[key]);
      });
    }

    return this.http
      .get<GameOver>(
        `${environment.apiBaseUrl}/event-client/api/playInstance/${playInstance}/event/casual`,
        {
          params,
        },
      )
      .pipe(
        map((resp) => {
          // add game image
          resp.eventPrototype.game.imageUrl =
            this.utilsService.getEventImageUrl(
              resp.eventPrototype.game.key,
              '-box-175.png',
            );
          resp.leaders.map((p) => {
            if (p.uuid === userUuid) {
              p.highlighted = true;
            }
          });

          return resp;
        }),
      );
  }
}
